<template>
  <div>
    <button class="trans-btn" @click="openModal">
      <img class="trans-icon"  src="/src/assets/icons/translate.svg" />
    </button>
    <ModalLang
        v-if="this.internalValue"
        @selectLang="selectLang"
        v-show="isModalVisible"
        :translations="this.internalValue"
        :translate-key="this.translateKey"
        :scope-lang="this.lang"
        @close="closeModal"
        @validate="validateModal"
    />
  </div>
</template>

<script>
import ModalLang from './ModalLang.vue'
import ScopeService from "../../modules/scope/ScopeService";

export default {
  name: 'Translator',
  props: ['value', 'lang', 'translateKey'],
  components: {ModalLang},
  data: function () {
    return {
      internalValue: null,
      isModalVisible: false,
      selectedLang: '',
    }
  },
  created: function () {
    this.internalValue = this.value;
  },
  methods: {
    openModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
    validateModal() {
      ScopeService.getTranslation(this.internalValue[this.selectedLang][this.translateKey], this.selectedLang, this.lang).then((val) => {
        this.$emit('updateValue', val.data)
      })
      this.isModalVisible = false
    },
    selectLang(lang) {
      this.selectedLang = lang
    }
  },
  watch: {
    'value'(newVal, oldVal) {
      this.internalValue = newVal
    },
    'internalValue'(newVal, oldVal) {
      this.$emit('input', this.internalValue);
    }
  }
}
</script>
<style scoped>
.trans-btn {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.25s ease-in-out;
}
.trans-btn:hover {
  background-color: var(--color-secondary-extra-light);
  transition: background-color 0.25s ease-in-out;
}
.trans-icon {
  height: auto;
  width: 1.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/form/Translator.vue